import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const LABELS = ["Odd/Even", "Red/Black", "Low/High", "Cards", "Baccarat"];

/**
 * Reference result body for Note Number (row.row5.worli-result):
 *   col-lg-7: the six drawn cards · col-lg-5: .casino-result-desc from rdesc split on "#".
 */
export default function NoteNumResultBody({ t1 }) {
  const cards = String(t1?.card || "")
    .split(",")
    .map((c) => c.trim())
    .filter(Boolean);
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5 worli-result">
      {cards.length ? (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <div className="casino-result-content-item text-center w-100">
              <div className="casino-result-cards">
                {[0, 1, 2, 3, 4, 5].map((i) => (
                  <React.Fragment key={i}>
                    {i > 0 ? " " : null}
                    <div className="casino-result-cards-item">
                      <img src={getCardImage(cards[i])} />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : null}{" "}
      <div className="col-12 col-lg-5">
        {desc.length ? (
          <div className="casino-result-desc">
            {LABELS.map((label, i) => (
              <React.Fragment key={label}>
                {i > 0 ? " " : null}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{desc[i]}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
